<template>
  <v-dialog v-model="showDialog" max-width="390" persistent>
    <v-card>
      <span style="float:right" class="ma-4">
        <v-icon v-on:click="discard()">clear</v-icon>
      </span>
      <v-card-title>
        <span class="body-2">{{ header }}</span>
      </v-card-title>
      <v-card-text>
        {{ text }}
      </v-card-text>
      <div class="text-center">
        <v-card-actions>
          <v-btn color="primary" outlined v-on:click="forwardToPurchase()">Abo upgraden</v-btn>
        </v-card-actions>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
const plans_specs = require("json-loader!yaml-loader!../specs/plans.yml");
function arrayToObject(arr, key) {
  var rv = {};
  for (var i = 0; i < arr.length; ++i) rv[arr[i][key]] = arr[i];
  return rv;
}
const products = arrayToObject(plans_specs.products, "id");

export default {
  name: "ActionImpossibleView",
  props: {
    actionType: String, // one of 'CREATE', 'UPDATE', 'PDF_PRINT'
    entityType: String, // one of 'COMP', 'PROC'. Optional
    number: Number,
    showThis: Boolean,
  },
  watch: {
    showThis: function(st) {
      this.showDialog = st;
    },
  },
  computed: {
    user_info() {
      return this.$store.state.originalStore.user_info;
    },
    num_companies() {
      return this.$store.state.copyProcesses.companies.length;
    },
    num_processes() {
      return this.$store.state.copyProcesses.companyProcesses.length;
    },
    product() {
      if (!this.user_info) {
        return undefined;
      }
      var product_id = this.user_info.attributes["custom:active_product_id"];
      var product = products[product_id];
      return product;
    },
    quota_type() {
      if (this.entityType) {
        return this.entityType;
      } else {
        if (!this.product) {
          return undefined;
        }
        return this.$props.actionType === "CREATE"
          ? this.num_companies >= this.product.usage.max_companies
            ? "COMP"
            : "PROC"
          : this.num_companies > this.product.usage.max_companies
          ? "COMP"
          : "PROC";
      }
    },
    quota_value() {
      return this.quota_type === "COMP" ? this.num_companies : this.number;
    },
    max_value() {
      if (!this.product) {
        return undefined;
      }
      return this.quota_type === "COMP" ? this.product.usage.max_companies : this.product.usage.max_processes;
    },
    plan_name() {
      if (!this.product) {
        return undefined;
      }
      return this.product.name;
    },
    quota_string() {
      return this.quota_type === "COMP" ? "Unternehmen" : "Verfahren";
    },
    header() {
      return "Kontingent erschöpft";
    },
    text() {
      return (
        (this.quota_type === "COMP" ? "Sie haben bereits " : "Das Unternehmen hat bereits ") +
        this.quota_value +
        " " +
        this.quota_string +
        ". Im aktuell gebuchten Abo " +
        this.plan_name +
        " können Sie maximal " +
        this.max_value +
        " " +
        this.quota_string +
        (this.quota_type === "COMP" ? "" : " pro Unternehmen") +
        " verwalten." +
        (this.actionType === "CREATE"
          ? " Um ein neues " + this.quota_string + " anzulegen, "
          : this.actionType === "UPDATE"
          ? " Um das " + this.quota_string + " zu bearbeiten, "
          : this.actionType === "PDF_PRINT"
          ? " Um das Verfahrensverzeichnis drucken zu können, "
          : this.actionType === "UPLOAD"
          ? " Um diese Verzeichnis-Vorlagen nutzen zu können, "
          : " Um fortfahren zu können, ") +
        "löschen Sie " +
        this.quota_string +
        " oder buchen Sie einen anderes Abonnement."
      );
    },
  },

  methods: {
    forwardToPurchase() {
      this.$emit("discard");
      this.$router.push({ path: "/home/plans" });
    },
    discard() {
      this.$emit("discard");
      this.showDialog = false;
    },
  },
  data: function() {
    return {
      showDialog: false,
      msg: null,
    };
  },
};
</script>

<style lang="stylus" scoped>
.v-progress-circular
  margin: 1rem
  align:center
</style>
